import { api } from "./api";
export const AddClusterApi = (params: any) => {
  return api.post(`/cluster/add`, {
    cluster_name:params.cluster_name,
    cluster_email:params.cluster_email,
    cluster_password: params.cluster_password,
    cluster_country: params.cluster_country,
    cluster_state: params.cluster_state,
    cluster_city: params.cluster_city,
    cluster_confirmPassword: params.cluster_confirmPassword
  });
};

export const UpdateClusterApi = (params: any) => {
  return api.post(`/cluster/updateById`, {
    cluster_name: params.cluster_name,
    cluster_email: params.cluster_email,
    cluster_country: params.cluster_country,
    cluster_state: params.cluster_state,
    cluster_city: params.cluster_city,
    cluster_serviceable_cities: params.cluster_serviceable_cities,
    cluster_clinics: params.cluster_clinics,
    id:params.id
  });
};

export const GetAllPractitionerByIdApi = (params: any) => {
  return api.post(`/practitioner/getById`,{
    id:params.id
  });
};

export const GetAllClusterApi = (params: any) => {
  return api.post(`/cluster/getAll`);
};

export const GetAllClusterByIdApi = (params: any) => {
  return api.post(`/cluster/getById`,{
    id:params.id
  });
};

export const GetAllClinicByIdApi = (params: any) => {
  return api.post(`/clinic/getById`,{
    id:params.id
  });
};

export const AddClinicApi = (params: any) => {
  return api.post(`/clinic/add`, {
    clinic_name:params.clinic_name,
    clinic_email:params.clinic_email,
    clinic_password: params.clinic_password,
    clinic_contact_type: params.clinic_contact_type,
    clinic_extn_code: params.clinic_extn_code,
    clinic_contact_no: params.clinic_contact_no,
    clinic_address_line1: params.clinic_address_line1,
    clinic_address_line2: params.clinic_address_line2,
    clinic_country: params.clinic_country,
    clinic_state: params.clinic_state,
    clinic_city: params.clinic_city,
    clinic_pincode:params.clinic_pincode,
    clinic_confirmPassword: params.clinic_confirmPassword
  });
};

export const GetAllClinicApi = (params: any) => {
  return api.post(`/clinic/getAll`);
};

export const AddPractitionerApi = (params: any) => {
  return api.post(`/practitioner/add`, {
    practitioner_code:params.practitioner_code,
    practitioner_gender:params.practitioner_gender,
    practitioner_email: params.practitioner_email,
    practitioner_password: params.practitioner_password,
    practitioner_first_name: params.practitioner_first_name,
    practitioner_last_name: params.practitioner_last_name,
    practitioner_extn_code: params.practitioner_extn_code,
    practitioner_phone_number: params.practitioner_phone_number,
    practitioner_timezone: params.practitioner_timezone,
    practitioner_slot_interval: params.practitioner_slot_interval,
    practitioner_country: params.practitioner_country,
    practitioner_state:params.practitioner_state,
    practitioner_city: params.practitioner_city,
    practitioner_pincode: params.practitioner_pincode,
    practitioner_confirm_password: params.practitioner_confirm_password,
    
  });
};

export const GetAllPractitionerApi = (params: any) => {
  return api.post(`/practitioner/getAll`);
};

export const modifyClusterStatusApi = (params: any) => {
  return api.post(`/cluster/makeActive`,{
    cluster_id:params.cluster_id,
    status:params.status
  });
};

export const modifyClinicStatusApi = (params: any) => {
  return api.post(`/clinic/makeActive`,{
    clinic_id:params.clinic_id,
    status:params.status
  });
};

export const modifyPractitionerStatusApi = (params: any) => {
  return api.post(`/practitioner/makeActive`,{
    practitioner_id:params.practitioner_id,
    status:params.status
  });
};

/*
 * THESE TWO USED TO POST `params` UNTOUCHED.
 *
 * Their callers passed { values: {...} }, so the request body was literally
 * {"values": {...}} — every field one level deeper than the server reads them,
 * and in the practitioner's case with no id anywhere at the top level. For a
 * route called updateById that cannot identify a record at all.
 *
 * Every other call in this file is flat with an explicit field list and `id`
 * beside it — AddPractitionerApi, AddClinicApi, GetAllPractitionerByIdApi and,
 * directly comparable, UpdateClusterApi above. These two now match it.
 *
 * Naming the fields rather than spreading also keeps Formik's own bookkeeping
 * and any stray UI state out of the request.
 */
export const UpdateClinicApi = (params: any) => {
  return api.post(`/clinic/updateById`, {
    id: params.id,
    clinic_id: params.clinic_id,
    clinic_name: params.clinic_name,
    clinic_email: params.clinic_email,
    clinic_contact_type: params.clinic_contact_type,
    clinic_extn_code: params.clinic_extn_code,
    clinic_contact_no: params.clinic_contact_no,
    clinic_address_line1: params.clinic_address_line1,
    clinic_address_line2: params.clinic_address_line2,
    clinic_country: params.clinic_country,
    clinic_state: params.clinic_state,
    clinic_city: params.clinic_city,
    clinic_pincode: params.clinic_pincode,
    clinic_billing_address_line1: params.clinic_billing_address_line1,
    clinic_billing_address_line2: params.clinic_billing_address_line2,
    clinic_billing_country: params.clinic_billing_country,
    clinic_billing_state: params.clinic_billing_state,
    clinic_billing_city: params.clinic_billing_city,
    clinic_billing_pincode: params.clinic_billing_pincode,
    clinic_practitioners: params.clinic_practitioners,
  });
};

export const UpdatePractitionerApi = (params: any) => {
  return api.post(`/practitioner/updateById`, {
    id: params.id,
    practitioner_id: params.practitioner_id,
    practitioner_code: params.practitioner_code,
    practitioner_gender: params.practitioner_gender,
    practitioner_email: params.practitioner_email,
    practitioner_first_name: params.practitioner_first_name,
    practitioner_last_name: params.practitioner_last_name,
    practitioner_extn_code: params.practitioner_extn_code,
    practitioner_phone_number: params.practitioner_phone_number,
    practitioner_sessions_per_slot: params.practitioner_sessions_per_slot,
    practitioner_timezone: params.practitioner_timezone,
    practitioner_slot_interval: params.practitioner_slot_interval,
    practitioner_address_line1: params.practitioner_address_line1,
    practitioner_address_line2: params.practitioner_address_line2,
    practitioner_country: params.practitioner_country,
    practitioner_state: params.practitioner_state,
    practitioner_city: params.practitioner_city,
    practitioner_pincode: params.practitioner_pincode,
  });
};

export const GetRolesApi = () => {
  return api.get(`/admin/roles`);
};

export const SetRolesApi = (params: any) => {
  return api.post(`/customer/setRoles`, {
    p_user_id: params.p_user_id,
    role_id: params.role_id
  });
};